import * as v from 'valibot';
import { IdSchema, TimestampSchema } from './common.js';
export const NumberingLevelFormatSchema = v.picklist([
    'numeric',
    'digit',
    'letter',
    'roman'
]);
export const NumberingCasingSchema = v.picklist(['upper', 'lower']);
export const NumberingLevelSchema = v.object({
    format: NumberingLevelFormatSchema,
    padding: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0)), 2),
    casing: v.optional(NumberingCasingSchema, 'upper')
});
export const NumberingConfigSchema = v.object({
    format: v.optional(NumberingLevelFormatSchema),
    padding: v.optional(v.pipe(v.number(), v.integer(), v.minValue(0))),
    casing: v.optional(NumberingCasingSchema),
    levels: v.optional(v.array(NumberingLevelSchema)),
    separator: v.optional(v.string(), '.')
});
export const RoomSchema = v.object({
    id: IdSchema,
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    ownerId: IdSchema,
    numberingConfig: NumberingConfigSchema,
    createdAt: TimestampSchema
});
export const CreateRoomSchema = v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    numberingConfig: v.optional(NumberingConfigSchema, {
        levels: [{ format: 'numeric', padding: 2 }],
        separator: '.'
    })
});
export const UpdateRoomSchema = v.partial(v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(255)),
    numberingConfig: NumberingConfigSchema
}));
//# sourceMappingURL=room.js.map